import { Tutoring } from "../components/tutoring/tutoring";

export const TutoringPage = () => {
  return <Tutoring />;
};
